module.exports = __webpack_public_path__ + "img/sample_pdf.2f013fbf.jpg";